import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    height: theme.spacing(16),
    width: theme.spacing(30),
    padding: theme.spacing(2),
    cursor: 'pointer',
    borderRadius: theme.spacing(1.5),
  },
  title: {
    fontSize: theme.spacing(2.5),
    fontWeight: 700,
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  headerText: {
    fontSize: theme.spacing(1.25),
    fontWeight: 'bold',
    backgroundColor: '#94FBAB',
    padding: theme.spacing(0.5, 1, 0.625, 1),
    borderRadius: theme.spacing(0.625),
    textAlign: 'center',
  },
}));
